import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
//
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
// ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// components
import TemplateSystem from "../components/TemplateSystem";
import ButtonMain from "../../common/components/button/ButtonMain";
import { StoreContext } from "../../store/StoreProvider";
import Act from "../../store/actions";

// utils
import fireDb from "../../api/firebase/realtime/utils";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

// 攔截個頁面的錯誤訊息後,使用者可以在此頁面手動送出請求
const SupportPage = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  // style
  const classes = useStyles();
  // props

  const [state, dispatch] = useContext(StoreContext);
  const { user, errorPage } = state;
  const { locale, displayName } = user;
  const { error: storeError } = errorPage;
  //
  const [localError, setLocalError] = useState(
    Array.isArray(storeError) ? storeError : [storeError]
  );

  useEffect(() => {
    setLocalError(Array.isArray(storeError) ? storeError : [storeError]);
  }, [storeError]);

  const messageSiteManager = (err) => {
    // save to firebase
    fireDb.creatLogError({
      data: {
        code: err.code || 400,
        message: err.message,
        userName: err.userName || displayName || "undefined",
        info: err.info,
        classification: err.classification || "undefined",
      },
      onSuccess: (key) => {
        // console.log("onSuccess key", key);
        // 送出訊息後, 清除 store 的狀態
        dispatch({
          type: Act.ERROR_CLEAR_ERROR,
          payload: err,
        });
        // 跳出訊息視窗
        dispatch({
          type: Act.COMMON_SET_SUCCESS_MESSAGE,
          payload: {
            open: true,
            content: intl.formatMessage({
              id: "supportpage.send.success",
              defaultMessage: "傳送訊息成功",
            }),
          },
        });
      },
      onError: (e) => {
        // console.log("onError err", e);
        // 跳出訊息視窗
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: intl.formatMessage({
              id: "supportpage.send.failure",
              defaultMessage: "傳送訊息失敗",
            }),
          },
        });
      },
    });
  };

  return (
    <TemplateSystem>
      <Grid container justifyContent="center">
        <Grid item>
          <Box pt={5} textAlign="center">
            <Typography variant="h5">
              {intl.formatMessage({
                id: "supportpage.title",
                defaultMessage: "支援中心",
              })}
            </Typography>
          </Box>
          <Box pt={5} width="700px">
            <Stack sx={{ width: "100%" }} spacing={2}>
              {localError.map((err, idx) => (
                <Box key={idx.toString()} mb={2}>
                  <Alert severity="error">
                    {intl.formatMessage({
                      id: "supportpage.error.message",
                      defaultMessage: "錯誤訊息",
                    })}
                    : {err.message}
                  </Alert>
                  <Grid container py={2} justifyContent="flex-start">
                    <ButtonMain
                      buttonProps={{
                        text: "通知網站管理者",
                        onClick: () => messageSiteManager(err),
                      }}
                    />
                  </Grid>
                </Box>
              ))}
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </TemplateSystem>
  );
};

SupportPage.propTypes = {};

SupportPage.defaultProps = {};

export default SupportPage;
